import React from 'react';
import { Card } from 'styleguide/Card';
import { DisplayXS, TextMDRegular } from 'styleguide/Texts';
import { View } from 'styleguide/View';
import { Spacing } from 'styleguide/spacing';

export const GenericErrorScreen = ({ error }: { error: string }) => {
  return (
    <View style={{ padding: Spacing.lg }}>
      <View style={{ maxWidth: 1148, width: '100%', alignSelf: 'center' }}>
        <Card>
          <DisplayXS style={{ marginBottom: Spacing.sm }}>Uh oh, something went wrong:</DisplayXS>
          <TextMDRegular>{error}</TextMDRegular>
        </Card>
      </View>
    </View>
  );
};
